import { BznavAppIds, IS_CLIENT } from '@repo/common-utils';

import { BznavReactNativeBridge } from '../services/BznavReactNativeBridge';
import type { ReactNativeMessageHandler } from '../types';

export let bridge: BznavReactNativeBridge | null = null;

export const initializeReactNativeBridge = (appId: BznavAppIds) => {
  if (bridge || !IS_CLIENT || !window.ReactNativeWebView) return;
  bridge = new BznavReactNativeBridge(appId);
};

export const addBznavMessageListener = (actionName: string, handler: ReactNativeMessageHandler) => {
  bridge?.addMessageHandler(actionName, handler);
};

export const removeBznavMessageListener = (actionName: string, handler?: ReactNativeMessageHandler) => {
  bridge?.removeMessageHandler(actionName, handler);
};

export const sendBznavNativeMessage = (actionName: string, data: unknown, callback?: ReactNativeMessageHandler, timeout?: number) => {
  return bridge?.sendNativeMessage(actionName, data, callback, timeout);
};
